var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("rb-common-modal", {
    attrs: {
      id: "rb-rox-protection-plan",
      "close-icon-mobile": "caret-big-left",
      "class-name": "rb-rox-protection-plan",
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [_c("rb-eyewear-protection-overlay-content")]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }